import { AICitationsResponse } from '../../services/brand-index.service';

export const sampleAICitationsData: AICitationsResponse = {
  "universities": [
    {
      "name": "Warwick Business School (YOU)",
      "citation_frequency": 65,
      "citation_share_of_voice": 60,
      "authority_weight": 70,
      "relevance_score": 75,
      "ai_readability": 68,
      "external_mentions": 55,
      "diversity_index": 72,
      "persistence_score": 66
    },
    {
      "name": "University of Oxford",
      "citation_frequency": 90,
      "citation_share_of_voice": 88,
      "authority_weight": 95,
      "relevance_score": 85,
      "ai_readability": 82,
      "external_mentions": 91,
      "diversity_index": 87,
      "persistence_score": 93
    },
    {
      "name": "London Business School",
      "citation_frequency": 75,
      "citation_share_of_voice": 70,
      "authority_weight": 78,
      "relevance_score": 80,
      "ai_readability": 74,
      "external_mentions": 68,
      "diversity_index": 79,
      "persistence_score": 77
    }
  ],
  "context": {
    "title": "AI Citation Analysis",
    "insights": [
      "University of Oxford leads in AI-related citations, indicating a strong research output in AI. It also shows high relevance and authority in the AI academic community.",
      "Warwick Business School demonstrates a balanced approach with a good authority weight and relevance score, though its external mentions are relatively lower.",
      "London Business School maintains a strong citation frequency and diversity index, reflecting its diverse AI research impact across various domains."
    ],
    "citations": [
      {
        "source": "DuckDuckGo",
        "url": "https://duckduckgo.com/?q=MBA%20rankings%20Global%202025",
        "title": "Search Results for: MBA rankings Global 2025",
        "snippet": "Search results for MBA rankings Global 2025 from DuckDuckGo search engine with comprehensive information and resources.",
        "confidence": 0.7,
        "category": "rankings"
      },
      {
        "source": "DuckDuckGo",
        "url": "https://duckduckgo.com/?q=MBA%20rankings%20Global%202024",
        "title": "Search Results for: MBA rankings Global 2024",
        "snippet": "Search results for MBA rankings Global 2024 from DuckDuckGo search engine with comprehensive information and resources.",
        "confidence": 0.7,
        "category": "rankings"
      },
      {
        "source": "DuckDuckGo",
        "url": "https://duckduckgo.com/?q=Warwick%20Business%20School%20%28YOU%29%20MBA%20ranking",
        "title": "Search Results for: Warwick Business School (YOU) MBA ranking",
        "snippet": "Search results for Warwick Business School (YOU) MBA ranking from DuckDuckGo search engine with comprehensive information and resources.",
        "confidence": 0.7,
        "category": "rankings"
      },
      {
        "source": "Study in UK",
        "url": "https://www.studying-in-uk.org/tuition-fees",
        "title": "UK University Tuition Fees Guide 2025",
        "snippet": "Comprehensive guide to tuition fees at UK universities 2025 including international student costs, financial aid options, and living expenses.",
        "confidence": 0.7,
        "category": "fees"
      },
      {
        "source": "Masters Portal",
        "url": "https://www.mastersportal.com/articles/2123/mba-tuition-fees-in-the-uk.html",
        "title": "MBA Tuition Fees UK Universities 2025 - Complete Guide",
        "snippet": "Detailed breakdown of MBA tuition fees across UK universities 2025, including international student costs and scholarship opportunities.",
        "confidence": 0.7,
        "category": "fees"
      },
      {
        "source": "Graduate Outcomes",
        "url": "https://www.graduateoutcomes.ac.uk",
        "title": "MBA Employment Report UK - Graduate Outcomes",
        "snippet": "Employment statistics and career outcomes for MBA graduates from UK universities, including salary data and industry placement.",
        "confidence": 0.7,
        "category": "employment"
      },
      {
        "source": "DuckDuckGo",
        "url": "https://duckduckgo.com/?q=MBA%20program%20details%20Global%20universities%202025",
        "title": "Search Results for: MBA program details Global universities 2025",
        "snippet": "Search results for MBA program details Global universities 2025 from DuckDuckGo search engine with comprehensive information and resources.",
        "confidence": 0.7,
        "category": "programs"
      },
      {
        "source": "DuckDuckGo",
        "url": "https://duckduckgo.com/?q=MBA%20program%20details%20Global%20universities%20latest",
        "title": "Search Results for: MBA program details Global universities latest",
        "snippet": "Search results for MBA program details Global universities latest from DuckDuckGo search engine with comprehensive information and resources.",
        "confidence": 0.7,
        "category": "programs"
      },
      {
        "source": "DuckDuckGo",
        "url": "https://duckduckgo.com/?q=Warwick%20Business%20School%20%28YOU%29%20MBA%20program",
        "title": "Search Results for: Warwick Business School (YOU) MBA program",
        "snippet": "Search results for Warwick Business School (YOU) MBA program from DuckDuckGo search engine with comprehensive information and resources.",
        "confidence": 0.7,
        "category": "programs"
      }
    ]
  },
  "timestamp": "2025-09-12T19:22:38.030265",
  "model_meta": {
    "model_used": "gpt-4o",
    "search_engines": [
      "DuckDuckGo Web Search"
    ],
    "data_freshness": "live",
    "processing_time": 22.07,
    "web_search_used": true,
    "citation_count": 9
  }
};
